<template>
  <div>
    <el-table :data="data"
              :show-header="false"
              :stripe="true"
              :span-method="span"
              border
              :cell-style="cellStyle">
      <el-table-column v-for="n in totalLevel"
                       :key="n"
                       width="120px">
        <template slot-scope="scope">
          <span style="white-space: pre-line;"
                :title="scope.row.col_key[n-1]">{{scope.row.col[n-1]}}{{scope.row.col_required[n-1] ? '（必填）' : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="200px">
        <template slot-scope="scope">
          <item-list v-if="useList(scope.row.item)"
                     :item="scope.row.item"
                     :id="dataID(scope.row.id)"
                     :disabled="disabled"
                     v-bind:value="dataForVModel[dataID(scope.row.id)]"
                     @input="onDataChanged" />
          <item-content v-else
                        :item="scope.row.item"
                        :id="dataID(scope.row.id)"
                        :disabled="disabled"
                        v-bind:value="dataForVModel[dataID(scope.row.id)]"
                        @input="onDataChanged" />
          <span style="color: red">{{errorForVModel[dataID(scope.row.id)]}}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="150px">
        <template slot-scope="scope">
          <div style="width: 100%; text-align: left;white-space: pre-line;">{{scope.row.item.hints}}</div>
        </template>
      </el-table-column>
      <el-table-column width="100px"
                       v-if="!disabled">
        <template slot-scope="scope">
          {{(scope.row.item.list ? '[' : '') + scope.row.item.type.join(',') + (scope.row.item.list ? ']' : '')}}
        </template>
      </el-table-column>
    </el-table>
    &nbsp;
    <el-table :data="[1]"
              :show-header="false"
              border
              :cell-style="cellStyle2">
      <el-table-column width="360px"><template>附件</template></el-table-column>
      <el-table-column><template>
          <item-list :item="{type: ['file'], list: true}"
                     :id="'attachments'"
                     :disabled="disabled"
                     v-bind:value="this.value.attachments"
                     @input="onDataChanged"></item-list>
        </template></el-table-column>
    </el-table>
    &nbsp;
    <el-container style="border: 1px solid #eee"
                  v-show="showAddChannel">
      <el-header style="height: 50px; background-color: #DCDFE6">
        添加渠道配置：<el-button v-for="(v, k) in this.missingChannels"
                   :key="k"
                   @click="addChannel(k)">{{v}}</el-button>
      </el-header>
      <el-main style="padding: 0">
      </el-main>
    </el-container>
    <el-container style="border: 1px solid #eee"
                  v-for="(chanData, k) in this.value.channel"
                  :key="k">
      <el-header style="background-color: #909399; height: 50px;">
        <el-button type="danger"
                   icon="el-icon-delete"
                   size="mini"
                   :disabled="disabled"
                   @click="removeChannel(k)"
                   circle></el-button><span style="margin-left: 10px">{{channels[k] || k}}</span>

      </el-header>
      <el-main style="padding: 0px; margin: -1px">
        <el-table :data="channelData"
                  :show-header="false"
                  :stripe="true"
                  :span-method="spanChannel"
                  border
                  :cell-style="cellStyle">
          <el-table-column v-for="n in totalLevel"
                           :key="n"
                           width="120px">
            <template slot-scope="scope">
              <span style="white-space: pre-line;"
                    :title="scope.row.col_key[n-1]">{{scope.row.col[n-1]}}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="200px">
            <template slot-scope="scope">
              <item-list v-if="useList(scope.row.item)"
                         :item="scope.row.item"
                         :id="chanID(k, scope.row.id)"
                         :disabled="disabled"
                         v-bind:value="dataForVModel[chanID(k, scope.row.id)]"
                         @input="onDataChanged" />
              <item-content v-else
                            :item="scope.row.item"
                            :id="chanID(k, scope.row.id)"
                            :disabled="disabled"
                            v-bind:value="dataForVModel[chanID(k, scope.row.id)]"
                            @input="onDataChanged" />
              <span style="color: red">{{errorForVModel[chanID(k, scope.row.id)]}}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="150px">
            <template slot-scope="scope">
              <div style="width: 100%; text-align: left;white-space: pre-line;">{{scope.row.item.hints}}</div>
            </template>
          </el-table-column>
          <el-table-column width="100px"
                           v-if="!disabled">
            <template slot-scope="scope">
              {{(scope.row.item.list ? '[' : '') + scope.row.item.type.join(',') + (scope.row.item.list ? ']' : '')}}
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

    <div style="margin-top: 10px"
         v-if="!disabled">
      <el-button type="primary"
                 v-if="!checkRequired || checkPassed"
                 @click="onSubmit">保存</el-button>
      <el-button type="primary"
                 @click="checkData">检查数据</el-button>
    </div>
    <div v-else>
      <el-button type="primary"
                 v-show="publish && checkRequired && checkPassed"
                 @click="onPublish">发布</el-button>
    </div>
  </div>
</template>

<style>
.el-header {
  background-color: #ebeef5;
  color: #333;
  line-height: 50px;
  text-align: left;
}
</style>

<script>
import ItemContent from './product_item/Content'
import ItemList from './product_item/List'
import pm from '../../util/product_management'
import { isObject, isArray } from 'lodash';

export default {
  name: "ProductItemForm",
  components: {
    ItemContent,
    ItemList
  },
  data() {
    return {
      dataForVModel: {},
      errorForVModel: {},
      checkPassed: false,
      totalLevel: 3,
      channels: {}
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: [Object],
    disabled: Boolean,
    checkRequired: Boolean,
    publish: Boolean
  },
  watch: {
    value() {
      this.checkPassed = false
      this.updateVModel()
    }
  },
  computed: {
    data() {
      return this.filterData(function (item) { return !!item.default })
    },
    channelData() {
      return this.filterData(function (item) { return !!item.channel })
    },
    missingChannels() {
      let chans = {}
      for (let k in this.channels) {
        if (!(k in (this.value.channel || {}))) {
          chans[k] = this.channels[k]
        }
      }

      return chans
    },
    showAddChannel() {
      return !this.disabled && Object.keys(this.missingChannels).length > 0
    }
  },
  async created() {
    let defines = await this.$store.dispatch('defines')
    this.channels = defines['channel'] || {}
  },
  updated() {
    this.updateVModel()
    if (this.checkRequired) {
      this.checkData()
    }
  },
  methods: {
    chanID(chan, id) {
      return 'channel.' + chan + '.' + id
    },
    dataID(id) {
      return 'data.' + id
    },
    filterData(filter) {
      let count = {}
      let result = []

      let func = (item_list, path) => {
        for (let item of item_list) {
          path.push(item)
          if ('children' in item) {
            func(item['children'], path)
          } else if (filter(item)) {
            let rs = {
              col: [],
              col_required: [],
              col_key: [],
              colspan: [],
              rowspan: []
            }

            let ks = []
            let last
            for (last of path) {
              ks.push(last.name)
              count[ks.join('.')] = (count[ks.join('.')] || 0) + 1

              rs.col.push(last.desc)
              rs.col_required.push(!!last.required)
              rs.col_key.push(last.name)
              rs.colspan.push(1)
              rs.rowspan.push(1)
            }
            rs.id = ks.join('.')
            rs.item = last.content
            rs.required = !!last.required

            rs.colspan[rs.colspan.length - 1] += this.totalLevel - rs.colspan.length

            result.push(rs)
          }
          path.pop()
        }
      };
      func(this.items, []);

      for (let row of result) {
        let v = row.id.split('.')
        v.pop()

        for (; v.length > 0;) {
          row.rowspan[v.length - 1] = count[v.join('.')] || 0
          count[v.join('.')] = 0
          v.pop()
        }
      }

      return result
    },
    updateVModel() {
      for (let item of this.data) {
        this.$set(this.dataForVModel, this.dataID(item.id), this.jsonGet(this.value, this.dataID(item.id).split('.')))
      }
      for (let k in this.value.channel) {
        for (let item of this.channelData) {
          this.$set(this.dataForVModel, this.chanID(k, item.id), this.jsonGet(this.value, this.chanID(k, item.id).split('.')))
        }
      }
    },
    span({ rowIndex, columnIndex }) {
      if (columnIndex > this.totalLevel - 1) {
        return {
          rowspan: 1, colspan: 1
        }
      } else {
        let r = this.data[rowIndex]
        return {
          rowspan: r.rowspan[columnIndex], colspan: r.colspan[columnIndex]
        }
      }
    },
    spanChannel({ rowIndex, columnIndex }) {
      if (columnIndex > this.totalLevel - 1) {
        return {
          rowspan: 1, colspan: 1
        }
      } else {
        let r = this.channelData[rowIndex]
        return {
          rowspan: r.rowspan[columnIndex], colspan: r.colspan[columnIndex]
        }
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex > this.totalLevel - 1) {
        return 'text-align: left'
      } else {
        return 'text-align: center; background-color: #f5f7fa; font-weight: bold'
      }
    },
    cellStyle2({ columnIndex }) {
      if (columnIndex > 0) {
        return 'text-align: left'
      } else {
        return 'text-align: center; background-color: #f5f7fa; font-weight: bold'
      }
    },
    checkData() {
      let currVal = this.value.data
      let ok = true
      for (let d of this.data) {
        if (d.required) {
          let r = this.jsonGet(currVal, d.id.split('.'))
          let new_err = ''
          if (r === null || r === undefined) {
            new_err = '必填项'
            ok = false
          }

          if (d.id in this.errorForVModel) {
            this.errorForVModel[this.dataID(d.id)] = new_err
          } else {
            this.$set(this.errorForVModel, this.dataID(d.id), new_err)
          }
        }
      }

      this.checkPassed = ok
      return ok
    },
    addChannel(k) {
      let newData = JSON.parse(JSON.stringify(this.value)) || {}
      if (!isObject(newData['channel']) || isArray(newData['channel']) ) {
        newData['channel'] = {}
      }
      console.log(newData);

      newData['channel'][k] = {}
      for (let item of this.channelData) {
        this.$set(this.dataForVModel, this.chanID(k, item.id), this.jsonGet(this.value, this.chanID(k, item.id).split('.')))
      }
      this.$emit('input', newData)
    },
    removeChannel(k) {
      this.$confirm("是否删除'" + (this.channels[k] || k) + "'的渠道数据?").then(() => {
        let newData = JSON.parse(JSON.stringify(this.value)) || {}
        if (!isObject(newData['channel']) || isArray(newData['channel'])) {
          newData['channel'] = {}
        }

        delete newData['channel'][k]
        this.$emit('input', newData)
      }).catch(() => { })
    },
    onDataChanged(data, id) {
      let newData = JSON.parse(JSON.stringify(this.value)) || {}
      let id_v = id.split('.')

      switch (id_v[0]) {
        case 'data':
          if (!isObject(newData['data']) || isArray(newData['data'])) {
            newData['data'] = {}
          }
          this.jsonSet(newData.data, id_v.slice(1), data)
          break;

        case 'channel':
          if (!isObject(newData['channel']) || isArray(newData['channel'])) {
            newData['channel'] = {}
          }
          if (!isObject(newData['channel'][id_v[1]]) || isArray(newData['channel'][id_v[1]])) {
            newData['channel'][id_v[1]] = {}
          }
          this.jsonSet(newData.channel[id_v[1]], id_v.slice(2), data)
          break;

        default:
          this.jsonSet(newData, id_v, data)
      }

      this.checkPassed = false
      this.dataForVModel[id] = data

      this.$emit('input', newData)
    },
    onSubmit() {
      if (!this.checkRequired || this.checkPassed) {
        this.$emit('submit')
      }
    },
    onPublish() {
      this.$emit('publish')
    },
    jsonGet(json, xpath) {
      if (xpath.length > 1) {
        if (xpath[0] in json && json[xpath[0]] !== null) {
          return this.jsonGet(json[xpath[0]], xpath.slice(1))
        }
        return undefined
      } else {
        return json[xpath[0]]
      }
    },
    jsonSet(json, xpath, value) {
      let key = xpath[0]
      xpath = xpath.slice(1)

      if (xpath.length > 0) {
        if (!isObject(json[key]) || isArray(json[key])) {
          json[key] = {}
        }

        this.jsonSet(json[key], xpath, value)
        if (Object.keys(json[key]).length === 0) {
          delete json[key]
        }

      } else {
        json[key] = value
        let v = JSON.stringify(value)
        if (v === '[]' || v === '{}' || v === 'null' || v === 'undefined' || v === '""') {
          delete json[key]
        }
      }
    },
    useList(item) {
      return pm.useList(item)
    }
  }
}
</script>